import React from 'react';
import styled, { css } from 'styled-components';
import { useRecoilValue } from 'recoil';
import { FlexCenter, CircleIcon } from '@ubeya/shared-web/components';
import { ReactComponent as Plus } from '@ubeya/shared-web/assets/plus-thin.svg';
import { media } from '@ubeya/shared-web/style';
import { showAllBranchesMode } from 'shared/atoms/scheduling';

const Wrapper = styled(FlexCenter).attrs(() => ({ className: 'plus-button' }))`
  ${({ $center }) =>
    !$center &&
    css`
      align-items: flex-start;
      padding-top: 30px;
    `}

  height: 100%;
  cursor: pointer;
  ${media.mobile`visibility: hidden;`}
`;

const Button = styled(CircleIcon)`
  margin-top: 5px;
`;

// The tooltip rides on the circle itself rather than the cell sized wrapper, so it points at the plus.
const PlusButton = ({ center = true, onClick, hideBackground, className, tooltip }) => {
  const showAllBranches = useRecoilValue(showAllBranchesMode);

  if (showAllBranches) {
    return null;
  }

  return (
    <Wrapper $center={center} onClick={onClick} className={className}>
      <Button hideBackground={hideBackground} icon={Plus} tooltip={tooltip} />
    </Wrapper>
  );
};

export default PlusButton;
